import { OrderPlanningActions } from "../../OrderPlanningActions";
import { DataSource, Layout, LayoutHeader, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutDriverManagement extends Layout {
    layoutOrderPlanningToolPanel: OrderPlanningActions;
    layoutheaderDriverManagement: LayoutHeader;
    panelSecondaryFilters: Panel;
    sourceDriverManager: DataSource;
    sourceDriverManagerProfile: DataSource;
    tableDriverManagement: Table;
}
